<template>
  <div>汇总页面</div>
</template>

<script>
  export default {
    name: 'all_md',
  }
</script>

<style scoped>

</style>